<pds-module-header title="Anymarket">
  <pds-new-breadcrumb [items]="[{ label: 'Operações', path: '/operacoes' }, { label: 'Anymarket' }]" />
    
  <div class="operations">
    <a class="operations__card" [routerLink]="['/operacoes', 'anymarket', 'publicacoes']" title="Publicações">
      <h2 class="operations__card__title">Publicações</h2>
      <div class="operations__card__subtitle">Permite gerenciar as publicações</div>
    </a>
  </div>
</pds-module-header>
